export default __webpack_public_path__ + "static/pupitre-96fefb4ebdd4965ffd5c14f34f2a498c.webp";